module.exports = __webpack_public_path__ + "img/IMG_6931.619535d8.webp";